import { Modal as BsModal } from 'react-bootstrap';

interface IOwnProps {
  title?: string;
  children?: React.ReactNode;
  show: boolean;
  handleClose: () => void;
  fullscreen?: boolean;
}

export const Modal: React.FC<IOwnProps> = (props: IOwnProps) => {
  return (
    <BsModal
      show={props.show}
      onHide={props.handleClose}
      backdrop="static"
      keyboard={false}
      fullscreen={props.fullscreen || 'sm-down'}
    >
      {props.title && (
      <BsModal.Header closeButton className="bg-primary-subtle">
        <BsModal.Title>{props.title}</BsModal.Title>
      </BsModal.Header>
      )}
      <BsModal.Body>
        {props.children}
      </BsModal.Body>
    </BsModal>
  );
};